import { createSlice } from "@reduxjs/toolkit";
import { addVacationAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addVacationSlice = createSlice({
  name: "addVacation",
  initialState: data,
  reducers: {
   addVacationSlice(state) {
      state.isLoading = true;
    },
   addVacationSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addVacationSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addVacationSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addVacationHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(addVacationAction.addVacationSlice());
    const response: any = await addVacationAPI(id,data);
    
   dispatch(addVacationAction.addVacationSliceSuccess(response));
  } catch (e: any) {
    dispatch(addVacationAction.addVacationSliceFailure(e?.response?.data));
  }
};
export default addVacationSlice.reducer;
export const addVacationAction = addVacationSlice.actions;
